import { DD_RUM_FEATURE_FLAG_VALUE_MAX_LENGTH } from './constants';

type DatadogFeatureFlagValue = boolean | number | string | null;

type NormalizedDatadogFeatureFlagValue = {
  cacheKey: string;
  value: DatadogFeatureFlagValue;
};

const UNSUPPORTED_FEATURE_FLAG_KEY_CHARACTERS = /[.:+\-=><!(){}\[\]\^"“”~*?\\|&]/g;

const truncateFlagValue = (value: string) =>
  value.length > DD_RUM_FEATURE_FLAG_VALUE_MAX_LENGTH
    ? value.slice(0, DD_RUM_FEATURE_FLAG_VALUE_MAX_LENGTH)
    : value;

export const normalizeDatadogFeatureFlagKey = (key: string) =>
  key.replace(UNSUPPORTED_FEATURE_FLAG_KEY_CHARACTERS, '_');

export const normalizeDatadogFeatureFlagValue = (
  value: unknown
): NormalizedDatadogFeatureFlagValue => {
  if (
    typeof value === 'boolean' ||
    typeof value === 'number' ||
    typeof value === 'string' ||
    value === null
  ) {
    return {
      cacheKey: JSON.stringify(value),
      value,
    };
  }

  const serialized = (() => {
    try {
      return JSON.stringify(value);
    } catch {
      return String(value);
    }
  })();

  const truncatedValue = truncateFlagValue(serialized ?? String(value));

  return {
    cacheKey: truncatedValue,
    value: truncatedValue,
  };
};
